import { Actions, RemoveSessionAction, Session } from "./types";
export const flowType = {
  linked: "linked" as const,
  unlinked: "unlinked" as const,
  pending: "pending" as const,
};

export const setSession = (session: Session) => {
  return {
    type: Actions.SET_SESSION,
    session,
  };
};
export const removeSession: RemoveSessionAction = () => {
  return { type: Actions.REMOVE_SESSION };
};
